import React from 'react';
import { Split } from '@dropbox/dig-foundations';
import { Button } from '@dropbox/dig-components/buttons';
import { Text } from '@dropbox/dig-components/typography';
import styles from './settings-navigation-tabs.module.css';

type SettingsNavigationTabsProps = {
  tabs: Array<{ id: string; title: string }>;
  activeTab: string;
};
export default function SettingsNavigationTabs({
  tabs,
  activeTab,
}: SettingsNavigationTabsProps) {
  return (
    <Split gap={'Macro Large'} isFlexGap={true}>
      {tabs.map((tab) => {
        return (
          <Split.Item key={`${tab.id}`}>
            <Button
              aria-selected={tab.id === activeTab}
              id={`${tab.id}_tab`}
              size={'large'}
              hasNoUnderline={tab.id !== activeTab}
              variant="transparent"
              href={`myAccount?current_tab=${tab.id}`}
              className={styles.navButton}
            >
              <Text
                color={tab.id === activeTab ? 'standard' : 'subtle'}
                size={'large'}
                isBold
              >
                {tab.title}
              </Text>
            </Button>
          </Split.Item>
        );
      })}
    </Split>
  );
}
